import { useEffect } from 'react';

import { isEmbeddedInCrmIframe } from '~shared/utils/is-embedded-in-crm-iframe';
import { attachIframeScrollChainGuard } from '~shared/utils/prevent-iframe-scroll-chain';

/**
 * When Studio runs inside the CRM iframe, block wheel events at scroll
 * boundaries so the parent CRM page cannot slide the iframe and clip the
 * sticky navbar.
 */
export function usePreventIframeScrollChain(): void {
  useEffect(() => {
    if (!isEmbeddedInCrmIframe()) return;
    return attachIframeScrollChainGuard();
  }, []);
}
